import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Dialog, Form, Input, Link, Table } from 'tdesign-react';
import { useMemoizedFn } from 'ahooks';
import useTable from '@/hooks/useTable';
import ModalHeader from '@/components/Header/Modal';

const { FormItem } = Form;

export default function Bundle({ detail, getListRequest }) {
  const [searchParams] = useSearchParams();
  const clusterName = searchParams.get('name');
  const [visible, setVisible] = useState(false);

  const columns = [
    {
      colKey: 'id',
      title: '序号',
      width: 80,
    },
    {
      colKey: 'topic',
      title: 'Topic',
    },
    {
      colKey: 'app',
      title: '归属应用',
      width: 200,
    },
  ];

  const onClose = () => {
    setVisible(false);
  };

  const loadData = useMemoizedFn(async (params) => {
    const { data } = await getListRequest({
      namespacePrefix: detail.namespacePrefix,
      clusterName,
      bundleRange: encodeURI(detail.bundleRange),
      ...params,
    });

    setData(
      data.map((item, index) => ({
        ...item,
        id: index + 1,
      })),
    );
  });

  const { config, header, doSearch, setData, data } = useTable({
    columns,
    onSearch: loadData,
    search: (
      <FormItem name='topic'>
        <Input placeholder='请输入Topic' clearable />
      </FormItem>
    ),
  });

  useEffect(() => {
    if (visible) {
      doSearch();
    }
  }, [doSearch, visible]);

  return (
    <>
      <Link theme='primary' onClick={() => setVisible(true)}>
        {detail.bundleRange}
      </Link>

      <Dialog
        header={
          <ModalHeader tags={[detail.bundleRange, `Topic总数：${data.length}`]}>Bundle</ModalHeader>
        }
        width={'80%'}
        style={{ minHeight: 400 }}
        placement='center'
        footer={null}
        onClose={onClose}
        destroyOnClose
        visible={visible}
      >
        {header}
        <Table {...config} />
      </Dialog>
    </>
  );
}
